import React from 'react';
import { useTheme } from '@mui/system';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface LabeledFieldProps {
  children: JSX.Element;
  isRequired?: boolean;
  label: string;
  sx?: any;
}

export default function LabeledField({
  children,
  isRequired,
  label,
  sx,
}: Readonly<LabeledFieldProps>) {
  const theme = useTheme();

  return (
    <Stack sx={sx}>
      <Typography
        sx={{
          marginBottom: '4px',
          marginTop: '12px',
        }}
        variant="body2"
      >
        {label}
        {isRequired && (
          <span style={{ color: theme.palette.error.main }}>{` *`}</span>
        )}
      </Typography>
      {children}
    </Stack>
  );
}
